import { gql } from '@apollo/client';

export const FETCH_USER_RELATED_ENTITIES = ({
  canReadClientLowRiskPii,
}: {
  canReadClientLowRiskPii: boolean;
}) => gql`
  query fetchUserRelatedEntities($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        id: stringId
        type
        state
        ${canReadClientLowRiskPii ? 'phone primaryEmail firstName middleName lastName' : ''}
        entityName
        relatedEntities {
          relation
          entity {
            id type state
            ${canReadClientLowRiskPii ? 'phone primaryEmail firstName middleName lastName' : ''}
            entityName
          }
        }
      }
    }
  }
`;

export const UPDATE_USER_RELATED_ENTITIES = gql`
  mutation updateUserRelatedEntities(
    $userId: ID!
    $relatedEntities: [RelatedEntityInput]
  ) {
    updateUser(input: { userId: $userId, relatedEntities: $relatedEntities }) {
      user {
        id
      }
    }
  }
`;
